export default __webpack_public_path__ + "static/media/activeEmergency.4ed6716e.svg";